
  import {defineComponent, ref, watch} from 'vue'
  import headers from './header/index.vue'
  import mainWeb from './main/index.vue'
  import bottom from './bottom/index.vue'
  import {useRoute} from "vue-router";
  export default defineComponent({
    name: 'index',
    components:{headers,mainWeb,bottom},
    setup(){
      const notShowBottom = ref(true)
      const route = useRoute()
      const whiteList = ['/solutions/detail']
      watch(()=>route.path,(newVal)=>{
        notShowBottom.value = false
        whiteList.forEach(item=>{
          if(newVal.includes(item)){
            notShowBottom.value = true
          }
        })
      },{
        immediate:true
      })
      return{
        route,
        notShowBottom,
      }
    }

  })
